import { createFileRoute } from "@tanstack/react-router";
import { options } from "@/pages/how-many-fps-are-gifs";

export const Route = createFileRoute("/blog/how-many-fps-are-gifs")(options);
